<template>
  <div>
    <el-table
      ref="table"
      :data="pageData.activeDiagRecord[tableCode]"
      :class="{ 'disabled-table': disabled }"
      highlight-current-row
      @row-click="handleRowClick"
      @current-change="handleCurrentChange"
    >
      <!--   饮片处方 start   -->
      <table-popup-item
        v-if="tableCode==='chmedPrescriptionItemList'"
        url="clinic/clinicdic/clinicmedicinedic/clinicmateriel"
        :searcher="{storeCode: pageData.storeCode, effectiveSign: '1', materielTypeSign: '3'}"
        :width="180"
        :filed-list="[
          { code: 'materielCode', name: '编码' },
          { code: 'materielName', name: '名称' },
        ]"
        :edit="!disabled"
        search-key="pinyinCode"
        name="药品名称"
        code="materielName"
        @onPopupClick="medPopupClick"
      />
      <table-select-item
        v-if="tableCode==='chmedPrescriptionItemList'"
        :edit="!disabled"
        :width="120"
        name="品质标识"
        code="qualitySign"
        :options="[{key:'1',value:'一般'},{key:'2',value:'精品'}]"
      />
      <table-number-item
        v-if="tableCode==='chmedPrescriptionItemList'"
        :width="140"
        :precision="0"
        :min="1"
        :edit="!disabled"
        name="单剂数量"
        code="singleNum"
      />
      <table-popup-item
        v-if="tableCode==='chmedPrescriptionItemList'"
        search-key="pinyinCode"
        url="clinic/clinicdic/clinicmedicinedic/clinicmeddic"
        :searcher="{storeCode: pageData.storeCode, medDirectoryCode: 'JZ', effectiveSign: '1'}"
        :width="140"
        :filed-list="[
          { code: 'medDictionaryCode', name: '编码' },
          { code: 'medDictionaryName', name: '名称' },
        ]"
        :edit="!disabled"
        name="煎法"
        code="decoctionName"
        @onPopupClick="decoctionPopupClick"
      />
      <el-table-column
        v-if="tableCode==='chmedPrescriptionItemList'"
        :width="140"
        label="总数"
        prop="doseNum"
      >
        <template #default="{row}">
          {{ (row["singleNum"] * pageData.activeDiagRecord.chmedPrescription.doseNum).toFixed(0) }}
        </template>
      </el-table-column>
      <!--   饮片处方 end   -->
      <!--   代煎处方 start   -->
      <table-popup-item
        v-if="tableCode==='djPrescriptionItemList'"
        url="clinic/clinicdic/clinicmedicinedic/clinicmateriel"
        :searcher="{storeCode: pageData.storeCode, effectiveSign: '1', materielTypeSign: '3'}"
        :width="180"
        :filed-list="[
          { code: 'materielCode', name: '编码' },
          { code: 'materielName', name: '名称' },
        ]"
        :edit="!disabled"
        search-key="pinyinCode"
        name="药品名称"
        code="materielName"
        @onPopupClick="medPopupClick"
      />
      <table-select-item
        v-if="tableCode==='djPrescriptionItemList'"
        :edit="!disabled"
        :width="120"
        name="品质标识"
        code="qualitySign"
        :options="[{key:'1',value:'一般'},{key:'2',value:'精品'}]"
      />
      <table-number-item
        v-if="tableCode==='djPrescriptionItemList'"
        :width="140"
        :precision="0"
        :min="1"
        :edit="!disabled"
        name="单剂数量"
        code="singleNum"
      />
      <table-popup-item
        v-if="tableCode==='djPrescriptionItemList'"
        search-key="pinyinCode"
        url="clinic/clinicdic/clinicmedicinedic/clinicmeddic"
        :searcher="{storeCode: pageData.storeCode, medDirectoryCode: 'JZ', effectiveSign: '1'}"
        :width="140"
        :filed-list="[
          { code: 'medDictionaryCode', name: '编码' },
          { code: 'medDictionaryName', name: '名称' },
        ]"
        :edit="!disabled"
        name="煎法"
        code="decoctionName"
        @onPopupClick="decoctionPopupClick"
      />
      <el-table-column
        v-if="tableCode==='djPrescriptionItemList'"
        :width="140"
        label="总数"
        prop="doseNum"
      >
        <template #default="{row}">
          {{ (row["singleNum"] * pageData.activeDiagRecord.djPrescription.doseNum).toFixed(0) }}
        </template>
      </el-table-column>
      <!--   饮片处方 end   -->
      <!--   代售处方 start   -->
      <table-popup-item
        v-if="tableCode==='dsPrescriptionItemList'"
        url="pharmacy/pharmacy/cooperation/cooperationmedicine"
        :searcher="{storeCode: pageData.storeCode, effectiveSign: '1', cooperationPharmacyCode: pageData.activeDiagRecord.dsPrescription.pharmacyCode}"
        :width="180"
        :filed-list="[
          { code: 'materielCode', name: '编码' },
          { code: 'materielName', name: '名称' },
        ]"
        :edit="!disabled"
        search-key="pinyinCode"
        name="药品名称"
        code="materielName"
        @onPopupClick="medPopupClick"
      />
      <table-select-item
        v-if="tableCode==='dsPrescriptionItemList'"
        :edit="!disabled"
        :width="120"
        name="品质标识"
        code="qualitySign"
        :options="[{key:'1',value:'一般'},{key:'2',value:'精品'}]"
      />
      <table-number-item
        v-if="tableCode==='dsPrescriptionItemList'"
        :width="140"
        :precision="0"
        :min="1"
        :edit="!disabled"
        name="数量"
        code="sellingNum"
      />
      <table-popup-item
        v-if="tableCode==='dsPrescriptionItemList'"
        search-key="pinyinCode"
        url="clinic/clinicdic/clinicmedicinedic/clinicmeddic"
        :searcher="{storeCode: pageData.storeCode, medDirectoryCode: 'JZ', effectiveSign: '1'}"
        :width="140"
        :filed-list="[
          { code: 'medDictionaryCode', name: '编码' },
          { code: 'medDictionaryName', name: '名称' },
        ]"
        :edit="!disabled"
        name="煎法"
        code="decoctionName"
        @onPopupClick="decoctionPopupClick"
      />
      <!--   饮片处方 end   -->
      <!--   中医药 start   -->
      <table-popup-item
        v-if="tableCode==='medPrescriptionItemList'"
        url="clinic/clinicdic/clinicmedicinedic/clinicmateriel"
        :searcher="{storeCode: pageData.storeCode, effectiveSign: '1', materielTypeSign: '1'}"
        :column-width="250"
        search-key="pinyinCode"
        :filed-list="[
          { code: 'materielCode', name: '编码' },
          { code: 'materielName', name: '名称' },
        ]"
        :edit="!disabled"
        name="药品名称"
        code="materielName"
        @onPopupClick="medPopupClick"
      />
      <table-select-item
        v-if="tableCode==='medPrescriptionItemList'"
        :edit="!disabled"
        default-value="1"
        :disabled="true"
        :width="120"
        name="品质标识"
        code="qualitySign"
        :options="[{key:'1',value:'一般'},{key:'2',value:'精品'}]"
      />
      <ik-column-number
        v-if="tableCode==='medPrescriptionItemList'"
        code="sellingNum"
        :column-width="150"
        :precision="0"
        :min="1"
        name="销售数量"
      />
      <ik-column-text
        v-if="tableCode==='medPrescriptionItemList'"
        code="medAdvice"
        name="医嘱"
      />
      <!--   中医药 end   -->
      <ik-column-text
        v-if="tableCode==='servePrescriptionItemList'"
        :edit="false"
        code="materielCode"
        name="方案编码"
      />
      <table-popup-item
        v-if="tableCode==='servePrescriptionItemList'"
        url="clinic/clinicdic/clinicmedicinedic/clinicmateriel"
        :searcher="{storeCode: pageData.storeCode, effectiveSign: '1', materielTypeSign: '4'}"
        :width="120"
        search-key="pinyinCode"
        :filed-list="[
          { code: 'materielCode', name: '编码' },
          { code: 'materielName', name: '名称' },
        ]"
        :edit="!disabled"
        name="方案名称"
        code="materielName"
        @onPopupClick="medPopupClick"
      />
      <ik-column-number
        v-if="tableCode==='servePrescriptionItemList'"
        code="sellingNum"
        :precision="0"
        :min="1"
        name="销售数量"
      />
      <el-table-column label="操作" fixed="right" align="center">
        <template #default="scope">
          <el-button type="text" :disabled="disabled" @click="delRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="add-btn-con w-full flex flex-row justify-center align-center" :class="{ 'disabled-add-btn': disabled }" @click="addRow">
      <div class="add-btn w-full h-full flex flex-row justify-center align-center">
        + 添加 +
      </div>
    </div>
  </div>
</template>

<script>
import IkColumnNumber from "@/components/ik/table/ikColumn/IkColumnNumber/index.vue"
import IkColumnText from "@/components/ik/table/ikColumn/IkColumnText/index.vue"

export default {
  name: "MedTable",
  components: { IkColumnText, IkColumnNumber },
  props: {
    tableCode: {
      type: String,
      default: "chmedPrescriptionItemList"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  inject: ["pageData"],
  data() {
    return {
      currentRowIndex: -1,
      currentColIndex: 0
    }
  },
  watch: {
    'pageData.activeDiagRecord.chmedPrescription.decoctionCode': {
      handler(newVal) {
        if (this.tableCode !== 'chmedPrescriptionItemList') return
        if (!newVal) return
        const chmed = this.pageData.activeDiagRecord.chmedPrescription
        const list = this.pageData.activeDiagRecord.chmedPrescriptionItemList
        if (list && list.length > 0) {
          list.forEach(item => {
            item.decoctionName = chmed.decoctionName
            item.decoctionCode = chmed.decoctionCode
            item.decoctionId = chmed.decoctionId
          })
        }
      }
    }
  },
  mounted() {
    this.addKeyListener()
  },
  beforeDestroy() {
    this.removeKeyListener()
  },
  methods: {
    decoctionPopupClick(line, code, row) {
      if (this.disabled) return
      this.pageData.activeDiagRecord[this.tableCode][line][code] = row["medDictionaryName"]
      this.pageData.activeDiagRecord[this.tableCode][line]["decoctionCode"] = row["medDictionaryCode"]
      this.pageData.activeDiagRecord[this.tableCode][line]["decoctionId"] = row["medDictionaryId"]
    },
    medPopupClick(line, code, row) {
      if (this.disabled) return
      this.pageData.activeDiagRecord[this.tableCode][line][code] = row["materielName"]
      this.pageData.activeDiagRecord[this.tableCode][line]["materielCode"] = row["materielCode"]
      this.pageData.activeDiagRecord[this.tableCode][line]["materielId"] = row["materielId"]
    },
    addRow() {
      if (this.disabled) return
      const defaultRow = { qualitySign: "1", singleNum: 1, sellingNum: 1 }
      if (this.tableCode === 'chmedPrescriptionItemList' || this.tableCode === 'djPrescriptionItemList') {
        const chmed = this.pageData.activeDiagRecord.chmedPrescription
        if (chmed && chmed.decoctionName) {
          defaultRow.decoctionName = chmed.decoctionName
          defaultRow.decoctionCode = chmed.decoctionCode
          defaultRow.decoctionId = chmed.decoctionId
        }
      }
      if (this.pageData.activeDiagRecord[this.tableCode]) {
        this.pageData.activeDiagRecord[this.tableCode].push(defaultRow)
      } else {
        this.pageData.activeDiagRecord[this.tableCode] = [defaultRow]
      }
      this.$nextTick(() => {
        const list = this.pageData.activeDiagRecord[this.tableCode]
        if (list && list.length > 0) {
          this.currentRowIndex = list.length - 1
          this.currentColIndex = 0
          this.$refs.table.setCurrentRow(list[this.currentRowIndex])
          this.scrollToRow(this.currentRowIndex)
          this.$nextTick(() => {
            this.focusCurrentCell()
          })
        }
      })
    },
    delRow(index) {
      if (this.disabled) return
      this.pageData.activeDiagRecord[this.tableCode].splice(index, 1)
      const list = this.pageData.activeDiagRecord[this.tableCode]
      if (this.currentRowIndex >= list.length) {
        this.currentRowIndex = list.length - 1
      }
      if (this.currentRowIndex >= 0) {
        this.$nextTick(() => {
          this.$refs.table.setCurrentRow(list[this.currentRowIndex])
          this.focusCurrentCell()
        })
      }
    },
    handleRowClick(row) {
      const list = this.pageData.activeDiagRecord[this.tableCode]
      const index = list.indexOf(row)
      if (index >= 0) {
        this.currentRowIndex = index
      }
    },
    handleCurrentChange(row) {
      if (row) {
        const list = this.pageData.activeDiagRecord[this.tableCode]
        this.currentRowIndex = list.indexOf(row)
      }
    },
    addKeyListener() {
      document.addEventListener('keydown', this.handleTableKeydown, true)
    },
    removeKeyListener() {
      document.removeEventListener('keydown', this.handleTableKeydown, true)
    },
    /**
     * 获取过滤后的数据行（排除空 tr）
     */
    getDataRows() {
      const allRows = this.$el.querySelectorAll('.el-table__body-wrapper tbody tr')
      return Array.from(allRows).filter(tr => tr.querySelector('td'))
    },
    /**
     * 判断当前键盘事件是否应由本实例处理
     */
    shouldHandleEvent() {
      if (document.querySelector('.v-modal') || document.querySelector('.el-dialog__wrapper:not([style*="display: none"])')) {
        return false
      }
      if (this.disabled) return false
      const list = this.pageData.activeDiagRecord[this.tableCode]
      if (!list) return false

      const activeEl = document.activeElement
      const isInThisTable = activeEl && this.$el.contains(activeEl)

      if (isInThisTable) return true

      if (activeEl === document.body || activeEl === document.documentElement) {
        if (this.$el.offsetParent === null) return false
        if (this.currentRowIndex < 0) return false
        return true
      }

      return false
    },
    handleTableKeydown(e) {
      if (!this.shouldHandleEvent()) return

      const list = this.pageData.activeDiagRecord[this.tableCode]

      // ↓ 键：有下一行则下移，否则新增一行
      if (e.key === 'ArrowDown') {
        e.preventDefault()
        e.stopPropagation()
        const newIndex = this.currentRowIndex + 1
        if (newIndex >= 0 && newIndex < list.length) {
          this.currentRowIndex = newIndex
          this.$refs.table.setCurrentRow(list[newIndex])
          this.scrollToRow(newIndex)
          this.focusCurrentCell()
        } else if (newIndex >= list.length) {
          this.addRow()
        }
        return
      }

      // ↑ 键：向上选行
      if (e.key === 'ArrowUp') {
        e.preventDefault()
        e.stopPropagation()
        const newIndex = this.currentRowIndex - 1
        if (newIndex >= 0 && newIndex < list.length) {
          this.currentRowIndex = newIndex
          this.$refs.table.setCurrentRow(list[newIndex])
          this.scrollToRow(newIndex)
          this.focusCurrentCell()
        }
        return
      }

      // ← → 键：在行内输入框之间移动焦点
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault()
        e.stopPropagation()
        this.syncIndexFromFocus()
        const direction = e.key === 'ArrowRight' ? 1 : -1
        this.moveColFocus(direction)
        return
      }

      // Enter 键：打开当前焦点所在行的药品名称弹窗
      if (e.key === 'Enter') {
        const activeEl = document.activeElement
        if (activeEl && (activeEl.tagName === 'INPUT' || activeEl.tagName === 'TEXTAREA')) {
          e.preventDefault()
          e.stopPropagation()
        }
        const isInThisTable = activeEl && this.$el.contains(activeEl)
        if (isInThisTable) {
          this.openPopupForFocusRow()
        } else {
          this.openPopupForRowIndex(this.currentRowIndex)
        }
        return
      }

      // Delete 键：删除当前选中行
      if (e.key === 'Delete' && this.currentRowIndex >= 0) {
        e.preventDefault()
        e.stopPropagation()
        this.delRow(this.currentRowIndex)
      }
    },
    syncIndexFromFocus() {
      const activeEl = document.activeElement
      if (!activeEl) return
      const tr = activeEl.closest ? activeEl.closest('tr') : this.findParentTr(activeEl)
      if (!tr) return
      const allRows = this.getDataRows()
      const rowIndex = allRows.indexOf(tr)
      if (rowIndex < 0) return
      this.currentRowIndex = rowIndex
      this.$refs.table.setCurrentRow(this.pageData.activeDiagRecord[this.tableCode][rowIndex])
      const cells = this.getEditableCellsByTr(tr)
      for (let i = 0; i < cells.length; i++) {
        if (cells[i].contains(activeEl)) {
          this.currentColIndex = i
          break
        }
      }
    },
    findParentTr(el) {
      let parent = el
      while (parent && parent.tagName !== 'TR') {
        parent = parent.parentElement
      }
      return parent
    },
    getEditableCellsByTr(tr) {
      if (!tr) return []
      return Array.from(tr.querySelectorAll('td')).filter(td => {
        if (td.querySelector('.el-button')) return false
        return td.querySelector('input, .el-select, .el-input-number, .el-input')
      })
    },
    getEditableCells() {
      const rows = this.getDataRows()
      return this.getEditableCellsByTr(rows[this.currentRowIndex])
    },
    moveColFocus(direction) {
      const cells = this.getEditableCells()
      if (cells.length === 0) return
      let newIndex = this.currentColIndex + direction
      if (newIndex < 0) newIndex = 0
      if (newIndex >= cells.length) newIndex = cells.length - 1
      this.currentColIndex = newIndex
      this.focusCell(cells[newIndex])
    },
    focusCurrentCell() {
      this.$nextTick(() => {
        const cells = this.getEditableCells()
        if (cells.length === 0) return
        if (this.currentColIndex >= cells.length) {
          this.currentColIndex = cells.length - 1
        }
        if (this.currentColIndex < 0) {
          this.currentColIndex = 0
        }
        this.focusCell(cells[this.currentColIndex])
      })
    },
    focusCell(cell) {
      if (!cell) return
      let input = cell.querySelector('input.el-input__inner')
      if (!input) {
        const elInput = cell.querySelector('.el-input')
        if (elInput) {
          input = elInput.querySelector('input')
        }
      }
      if (!input) {
        input = cell.querySelector('input')
      }
      if (input) {
        input.focus()
        if (typeof input.select === 'function') {
          input.select()
        }
      }
    },
    openPopupForFocusRow() {
      setTimeout(() => {
        const activeEl = document.activeElement
        if (!activeEl) return
        const tr = activeEl.closest ? activeEl.closest('tr') : this.findParentTr(activeEl)
        if (!tr) return
        const allRows = this.getDataRows()
        const rowIndex = allRows.indexOf(tr)
        if (rowIndex < 0) return
        this.currentRowIndex = rowIndex
        this.$refs.table.setCurrentRow(this.pageData.activeDiagRecord[this.tableCode][rowIndex])
        const cells = this.getEditableCellsByTr(tr)
        let colIndex = 0
        for (let i = 0; i < cells.length; i++) {
          if (cells[i].contains(activeEl)) {
            colIndex = i
            break
          }
        }
        this.currentColIndex = colIndex
        if (cells.length > 0) {
          this.triggerCellPopup(cells[0])
        }
      }, 50)
    },
    openPopupForRowIndex(rowIndex) {
      if (rowIndex < 0) return
      const list = this.pageData.activeDiagRecord[this.tableCode]
      if (!list || rowIndex >= list.length) return
      this.currentRowIndex = rowIndex
      this.currentColIndex = 0
      this.$refs.table.setCurrentRow(list[rowIndex])
      setTimeout(() => {
        const rows = this.getDataRows()
        const tr = rows[rowIndex]
        if (!tr) return
        const cells = this.getEditableCellsByTr(tr)
        if (cells.length > 0) {
          this.triggerCellPopup(cells[0])
        }
      }, 50)
    },
    triggerCellPopup(cell) {
      if (!cell) return
      let input = cell.querySelector('input.el-input__inner')
      if (!input) {
        const elInput = cell.querySelector('.el-input')
        if (elInput) input = elInput.querySelector('input')
      }
      if (!input) {
        input = cell.querySelector('input')
      }
      if (!input) return
      if (document.activeElement === input) {
        input.blur()
        this.$nextTick(() => {
          input.focus()
        })
      } else {
        input.focus()
      }
    },
    scrollToRow(index) {
      this.$nextTick(() => {
        const rows = this.getDataRows()
        if (rows[index]) {
          rows[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-btn-con {
  background: #FFFFFF;
  height: 46px;
  border: 1px solid #E5E6EB;
  padding: 7px;

  &:hover {
    cursor: pointer;
  }

  .add-btn {
    background: #F7F8FA;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #E5E6EB;

    font-family: PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 14px;
    color: #4E5969;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
/* 新增禁用状态样式 */
.disabled-table {
  opacity: 0.6;
}

.disabled-add-btn {
  opacity: 0.6;
  cursor: not-allowed !important;

  .add-btn {
    background-color: #f5f5f5 !important;
    color: #999 !important;
    border-color: #e0e0e0 !important;
  }

  &:hover .add-btn {
    background-color: #f5f5f5 !important;
  }
}

.add-btn-con {
  background: #FFFFFF;
  height: 46px;
  border: 1px solid #E5E6EB;
  padding: 7px;

  &:hover {
    cursor: pointer;
  }

  .add-btn {
    background: #F7F8FA;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #E5E6EB;
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 14px;
    color: #4E5969;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
